export const tip = 'tip'
const ai_module_route = {
    tip:`/${tip}`
}

export default ai_module_route
